/** Shared classes so the Filter and Display menus stay visually identical. */
export const MENU_TRIGGER_CLASSNAME = "h-8 gap-1.5 px-2.5 text-muted-foreground";
export const MENU_ITEM_CLASSNAME = "cursor-pointer text-[13px]";
export const MENU_LABEL_CLASSNAME = "text-[11px] font-medium tracking-[0.04em] text-muted-foreground";
